import AudioSettings from "@/AudioSettings";
import { PlayerButtons } from "@/components/AudioPlayer/PlayerButtons";
import Icon from "@/components/Icon";
import RecitersGrid from "@/components/RecitersGrid";
import { VerseInfo } from "@/components/Widgets";
import useSnapHeightToBottomOf from "@/hooks/useSnapHeightToBottomOff";
import { analytics } from "@/services/analytics";
import { selectAppHeight, selectIsNarrow } from "@/store/layoutSlice";
import { selectPlayingAya } from "@/store/playerSlice";
import {
	selectAiAgent,
	selectLang,
	selectTheme,
	setAiAgent,
	setLang,
	setTheme,
} from "@/store/settingsSlice";
import { saveAiAgent } from "@/store/dbSlice";
import { selectPopup } from "@/store/uiSlice";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { FormattedMessage as Message } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";

const Settings = () => {
	const lang = useSelector(selectLang);
	const theme = useSelector(selectTheme);
	const aiAgent = useSelector(selectAiAgent);
	const dispatch = useDispatch();
	const appHeight = useSelector(selectAppHeight);
	const bodyRef = useSnapHeightToBottomOf(appHeight - 15);

	const isNarrow = useSelector(selectIsNarrow);
	const popup = useSelector(selectPopup);
	const playingAya = useSelector(selectPlayingAya);

	const onUpdateTheme = (checked: boolean) => {
		const theme_name = checked ? "Dark" : "Default";
		dispatch(setTheme(theme_name));
		localStorage.setItem("theme", theme_name);
		analytics.logEvent("set_theme", { theme_name, trigger: popup });
	};

	const updateLang = ({
		currentTarget,
	}: React.ChangeEvent<HTMLSelectElement>) => {
		const lang = currentTarget.value;
		dispatch(setLang(lang));
		analytics.logEvent("set_lang", { lang, trigger: popup });
	};

	const updateAiAgent = ({
		currentTarget,
	}: React.ChangeEvent<HTMLSelectElement>) => {
		const agent = currentTarget.value;
		dispatch(setAiAgent(agent));
		dispatch(saveAiAgent(agent));
		analytics.logEvent("set_ai_agent", { agent, trigger: popup });
	};

	return (
		<>
			<div className="Title">
				<VerseInfo trigger="settings_title" verse={playingAya} />
				{isNarrow ? (
					<PlayerButtons
						trigger="settings_title"
						showReciter={true}
					/>
				) : (
					""
				)}
			</div>
			<div className="PopupBody" ref={bodyRef}>
				<div className="OptionRow">
					<label>
						<span>
							<Icon icon={faLanguage} />
						</span>
						<select onChange={updateLang} value={lang}>
							<option value="ar">عربي</option>
							<option value="en">English</option>
							<option value="fr">Français</option>
							<option value="tr">Türkçe</option>
							<option value="id">Bahasa Indonesia</option>
							<option value="ms">Bahasa Melayu</option>
							<option value="fa">فارسی</option>
							<option value="ur">اردو</option>
							<option value="de">Deutsch</option>
							<option value="it">Italiano</option>
							<option value="nl">Nederlands</option>
							<option value="es">Español</option>
						</select>
					</label>
				</div>
				<hr />
				<div className="OptionRow">
					<label>
						<span>
							<Message id="dark_mode" />
						</span>
						<Switch
							height={22}
							width={42}
							onChange={onUpdateTheme}
							checked={theme === "Dark"}
						/>
					</label>
				</div>
				<div className="OptionRow">
					<label>
						<span>
							<Message id="ai_agent" />
						</span>
						<select onChange={updateAiAgent} value={aiAgent}>
							<option value="AskUser"><Message id="ask_user" /></option>
							<option value="Google">Google</option>
							<option value="Perplexity">Perplexity</option>
							<option value="Claude">Claude</option>
							<option value="ChatGPT">ChatGPT</option>
							{/* <option value="Meta">Meta</option> */}
						</select>
					</label>
				</div>
				{/* <ExerciseSettings />
                <hr /> */}
				<hr />
				<div>
					<Message id="audioplayer" />:
				</div>
				<AudioSettings />
				<hr />
				<div>
					<Message id="select_reciter" />:
				</div>
				<RecitersGrid />
			</div>
		</>
	);
};

export default Settings;
